import { LoadedContent } from "src/components/common/loading/loadedContent";
import { InputModalContentLayout } from "../common/InputModalContentLayout";
import { useTargetInventoryDependencies } from "./dependencies";
import { TargetInventoryTable } from "./table";

export const TargetInventoryEditor = () => {
  return (
    <LoadedContent data={useTargetInventoryDependencies()} enableFullHeight>
      {({ materials, targetInventory, currentInventory }) => (
        <InputModalContentLayout
          leftPanel={
            <TargetInventoryTable
              materials={materials}
              targetInventory={targetInventory}
              currentInventory={currentInventory}
            />
          }
          rightPanel={null}
          bottomPanel={null}
          removeLeftPanelOutline
          fullWidthLeftPanel
        />
      )}
    </LoadedContent>
  );
};
